import Phaser from "phaser";
import { createModernTextures } from "../art/modernArt";
import { GAME_HEIGHT, GAME_WIDTH } from "../constants";
import { TEAMMATES } from "../data/teammates";
import {
  AUDIO_CLIP_FILES,
  synthAudio,
  type AudioClip,
} from "../systems/SynthAudio";

export class BootScene extends Phaser.Scene {
  constructor() {
    super("BootScene");
  }

  preload(): void {
    this.cameras.main.setBackgroundColor(0x11152e);
    const track = this.add
      .rectangle(GAME_WIDTH / 2, GAME_HEIGHT / 2, 280, 12, 0x222946)
      .setOrigin(0.5);
    const fill = this.add
      .rectangle(GAME_WIDTH / 2 - 136, GAME_HEIGHT / 2, 0, 8, 0x46e6d4)
      .setOrigin(0, 0.5);
    this.load.on("progress", (progress: number) => {
      fill.width = 272 * progress;
    });
    this.load.once("complete", () => {
      track.destroy();
      fill.destroy();
    });

    for (const id of TEAMMATES) {
      // True RGBA heads produced by scripts/process-portraits.mjs.
      this.load.image(
        `portrait-${id}`,
        `assets/portraits/transparent/${id}.png`,
      );
    }
    // Soundtrack bytes are fetched here so the loading bar covers them; the
    // audio system decodes them once the browser allows an AudioContext.
    for (const [clip, url] of Object.entries(AUDIO_CLIP_FILES)) {
      this.load.binary(`audio-${clip}`, url);
    }
    this.load.on(
      Phaser.Loader.Events.FILE_LOAD_ERROR,
      (file: Phaser.Loader.File) => {
        console.warn(`Asset failed to load: ${file.key} (${file.url})`);
      },
    );
  }

  create(): void {
    for (const clip of Object.keys(AUDIO_CLIP_FILES) as AudioClip[]) {
      const key = `audio-${clip}`;
      if (this.cache.binary.has(key)) {
        synthAudio.registerClip(clip, this.cache.binary.get(key) as ArrayBuffer);
        this.cache.binary.remove(key);
      }
    }
    createModernTextures(this);
    this.scene.start("MenuScene");
  }
}
